// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

// Get environment variables for Supabase connection
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate the Supabase credentials
const hasMissingCredentials = !supabaseUrl || !supabaseAnonKey || 
  supabaseUrl === 'YOUR_SUPABASE_URL' || 
  supabaseAnonKey === 'YOUR_SUPABASE_ANON_KEY';

// Create a flag to track Supabase configuration status
export const supabaseConfigured = !hasMissingCredentials;

if (hasMissingCredentials) {
  console.error(
    'Supabase credentials are missing or invalid. ' +
    'Saved jobs functionality will not work. ' +
    'Make sure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY ' +
    'are set correctly in your environment variables.'
  );
}

// Create the Supabase client (even with invalid credentials, but we'll handle errors in the app)
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co', 
  supabaseAnonKey || 'placeholder-key'
);

// Test connection and log status
if (supabaseConfigured) {
  console.info(`Connecting to Supabase at: ${supabaseUrl}`);
  supabase.auth.getSession().then(({ data, error }) => {
    if (error) {
      console.error('Supabase connection error:', error.message);
    } else {
      console.info('Supabase connection successful');
    }
  });
}